<template>
    <div class="flex flex-col lg:flex-row min-h-screen">
        <!-- Left Section with Images - Hidden on mobile -->
        <div class="hidden lg:block w-1/2 bg-gray-50 p-12 relative">
            <div class="absolute top-8 left-12 flex items-center">
                <!-- <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-blue-600 mr-2" viewBox="0 0 20 20"
                    fill="currentColor">
                    <path fill-rule="evenodd"
                        d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z"
                        clip-rule="evenodd" />
                </svg> -->
                <router-link to="/" class="flex items-center cursor-pointer">
  <img src="../assets/optimaAI.png" alt="OptimaAI Logo" class="h-8 w-8 mr-2">
  <h3 class="text-xl font-semibold text-gray-900">OptimaAI Creator</h3>
</router-link>

            </div>

            <div class="h-full flex items-start justify-center pt-12">
                <div class="relative w-[450px] h-[250px] flex items-center justify-center mb-16">
                    <!-- First image (left) -->
                    <div class="absolute left-[5%] top-[45%] -translate-y-1/2 w-52 h-52">
                        <img src="../assets/account1.png"
                            class="w-full h-full rounded-full object-cover shadow-lg border-4 border-white"
                            alt="Profile 1" />
                    </div>

                    <!-- Second image (middle-right) -->
                    <div class="absolute left-[50%] top-[92%] -translate-y-2/3 w-40 h-40">
                        <img src="../assets/account2.png"
                            class="w-full h-full rounded-full object-cover shadow-lg border-4 border-white"
                            alt="Profile 2" />
                    </div>

                    <!-- Third image (bottom-middle) -->
                    <div class="absolute left-[20%] top-[90%] w-36 h-36">
                        <img src="../assets/account3.png"
                            class="w-full h-full rounded-full object-cover shadow-lg border-4 border-white"
                            alt="Profile 3" />
                    </div>
                </div>
            </div>

            <div class="absolute bottom-12 left-12">
                <div class="max-w-[400px] mt-8">
                    <h2 class="text-xl font-bold text-gray-800 leading-tight mb-2">
                        Your content, your schedule, your<br />
                        control
                    </h2>
                    <p class="text-gray-500 text-sm leading-relaxed">
                        Built for creators, powered by AI. Take control of your<br />
                        content and grow your audience.
                    </p>
                </div>
            </div>
        </div>

        <!-- Right Section with Login Form -->
        <div
            class="w-full lg:w-1/2 min-h-screen flex flex-col items-center justify-center lg:justify-start p-6 lg:p-12">
            <!-- Mobile Header -->
            <div class="lg:hidden flex items-center mb-8">
                <img src="../assets/optimaAI.png" alt="" class="h-8 w-8 mr-2">
                <h3 class="text-xl font-semibold text-gray-900">OptimaAI Creator</h3>
            </div>

            <div class="w-full max-w-[400px] px-4 lg:mt-16">
                <h1 class="text-xl lg:text-xl font-bold mb-2">Welcome back</h1>
                <p class="text-gray-600 mb-6 text-sm">Log in to your creator account</p>

                <form @submit.prevent="handleLogin" class="space-y-4">
                    <div class="space-y-3">
                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-1">Email address</label>
                            <div class="relative">
                                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400"
                                        viewBox="0 0 20 20" fill="currentColor">
                                        <path
                                            d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                        <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                                    </svg>
                                </div>
                                <input type="email" v-model="email" placeholder="Enter your email"
                                    class="w-full pl-10 pr-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                                    required />
                            </div>
                        </div>

                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-1">Password</label>
                            <div class="relative">
                                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400"
                                        viewBox="0 0 20 20" fill="currentColor">
                                        <path fill-rule="evenodd"
                                            d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                                            clip-rule="evenodd" />
                                    </svg>
                                </div>
                                <input :type="showPassword ? 'text' : 'password'" v-model="password"
                                    placeholder="Enter your password"
                                    class="w-full pl-10 pr-10 py-2 border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                                    required />
                                <button type="button" @click="showPassword = !showPassword"
                                    class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700">
                                    <svg v-if="!showPassword" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5"
                                        fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                    </svg>
                                    <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none"
                                        viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="flex items-center justify-between">
                        <label class="flex items-center">
                            <input type="checkbox"
                                class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                            <span class="ml-2 text-sm text-gray-600">Remember me</span>
                        </label>
                        <a @click="goToForgotPassword"
                            class="text-sm text-blue-600 hover:text-blue-800 cursor-pointer">Forgot password?</a>
                    </div>

                    <div v-if="error" class="text-red-500 text-sm text-center">
                        {{ error }}
                    </div>

                    <div v-if="successMessage" class="text-green-500 text-sm text-center">
                        {{ successMessage }}
                    </div>

                    <button type="submit"
                        class="w-full py-2 px-4 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded transition duration-200 flex items-center justify-center"
                        :disabled="isLoading">
                        <svg v-if="isLoading" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                            xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4">
                            </circle>
                            <path class="opacity-75" fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                            </path>
                        </svg>
                        {{ isLoading ? 'Logging in...' : 'Log in' }}
                    </button>

                    <p class="text-center text-gray-600 text-sm">
                        Don't have an account?
                        <a @click="$router.push('/signup')"
                            class="text-blue-600 hover:text-blue-800 cursor-pointer">Sign up</a>
                    </p>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { useToast } from 'vue-toastification/dist/index.mjs';

export default {
    name: 'Login-component',
    setup() {
        const toast = useToast();
        return { toast }
    },
    data() {
        return {
            email: '',
            password: '',
            error: null,
            successMessage: null,
            showPassword: false,
            isLoading: false,
            isForgotPasswordLoading: false
        }
    },
    methods: {
        async goToForgotPassword() {
            try {
                this.error = null;
                this.isForgotPasswordLoading = true;
                const apiUrl = process.env.VUE_APP_API_URL || 'http://localhost:5000';
                const response = await axios.post(`${apiUrl}/api/auth/forget-password`, {
                    email: this.email
                });

                if (response.data.success) {
                    this.toast.success(response.data.message || "Password reset link sent to your email!");
                    // Redirect to reset password page with token
                    if (response.data.token) {
                        this.$router.push(`/reset-password/${response.data.token}`);
                    }
                }
            } catch (error) {
                console.error('Forgot password error:', error);
                this.toast.error(error.response?.data?.message || error.message || 'An error occurred while processing your request');
            } finally {
                this.isForgotPasswordLoading = false;
            }
        },
        async handleLogin() {
            try {
                this.error = null;
                this.isLoading = true;
                const apiUrl = process.env.VUE_APP_API_URL || 'http://localhost:5000';
                const response = await axios.post(`${apiUrl}/api/auth/login`, {
                    email: this.email,
                    password: this.password
                });
                if (response.data.token) {
                    localStorage.setItem('token', response.data.token);
                    // Store user data in localStorage
                    const creator = response.data.creator;
                    localStorage.setItem('creator', JSON.stringify(creator));
                    
                    this.toast.success("Login successful! Redirecting...");
                    
                    setTimeout(() => {
                        const role = creator.role || creator._doc?.role;
                        if (role === 'admin') {
                            this.$router.push('/admin/support');
                        } else {
                            this.$router.push('/dashboard');
                        }
                    }, 1500);
                } else {
                    throw new Error('No token received');
                }
            } catch (error) {
                console.error('Login error:', error);
                this.toast.error(error.response?.data?.message || error.message || 'An error occurred during login');
            } finally {
                this.isLoading = false;
            }
        }
    }
}
</script>

<style scoped>
/* Add any additional custom styles here */
button:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}
</style>